import React from "react";
import TicketListPage from "./TicketListPage";

const DealerSupport = () => <TicketListPage partyType="Dealer" title="Dealer Support" accentColor="#f59e0b" />;

export default DealerSupport;
